import { render, staticRenderFns } from "./ProductsViewContent.vue?vue&type=template&id=c50125ac&scoped=true"
import script from "./ProductsViewContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsViewContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductsViewContent.vue?vue&type=style&index=0&id=c50125ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50125ac",
  null
  
)

export default component.exports